import React from 'react';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-124" data-mp="2ln2ee50o55nw">
      <div className="mx-auto max-w-2xl" data-id="element-125" data-mp="2lmiy0sqo2pbz">
        <h2 className="text-center text-lg font-extrabold uppercase leading-tight text-navy sm:text-3xl" data-id="element-126" data-mp="26ypg31e3zaq8">
          Does this sound familiar?
        </h2>
        <p className="mt-1 text-center text-sm font-semibold leading-snug text-navy sm:text-base" data-id="element-127" data-mp="2bvocjql8vtrl">
          You understand the theory—but when you're looking at an unfamiliar
          microscopic image, suddenly everything starts to look similar.
        </p>
        <p className="mt-1 text-center text-sm leading-snug sm:text-base" data-id="element-128" data-mp="1o0d9nnel0eyc">
          If you're studying medicine, histology, pathology, biomedical science,
          medical laboratory science, histotechnology, or another health-science
          field, you've probably experienced at least one of these situations:
        </p>

        <div className="mt-2 space-y-2" data-id="element-129" data-mp="3nc5y2vnb0bzg">
          {painPoints.map(p => <div key={p.title} data-id="element-130" data-mp="1yzn53nbw7eho">
              <article className="rounded-md border-l-4 border-magenta bg-blush/30 px-2.5 py-2" data-id="element-131" data-mp="1yyu30znvpd5v">
                <h3 className="text-sm font-extrabold uppercase leading-tight text-navy sm:text-base" data-id="element-132" data-mp="1u1bx7i55re23">
                  {p.title}
                </h3>
                {p.paragraphs.map(para => <p key={para} className="mt-1 text-sm leading-snug sm:text-base" data-id="element-133" data-mp="23s6q35cwtbwi">
                    {para}
                  </p>)}
              </article>
              {p.callout ? <p className="mt-2 rounded-md bg-navy px-3 py-2 text-center font-heading text-sm font-extrabold leading-snug text-white sm:text-base" data-id="element-134" data-mp="1b4subaky6mdz">
                  {p.callout}
                </p> : null}
            </div>)}
        </div>
      </div>
    </section>;
}